import { useMutation } from "@shared/lib/hooks";
import { AgencyService } from "../services/agency.service";
import { ToastService } from "@shared/lib/services";
import { AGENCY_LIST_QUERY_KEY } from "../constants/querykeys";
import { BackednResponse } from "@shared/lib/types";
import { Agency, AgencyUser } from "@shared/lib/types/agency";

export function useEditAgencyUser() {
  const {
    mutate: editAgencyUser,
    isLoading: isEditing,
    isSuccess: isEdited,
  } = useMutation<
    { agencyId: string; agencyUser: AgencyUser },
    BackednResponse<Agency> | void
  >({
    mutationFn: async ({ agencyId, agencyUser }) => {
      return (await AgencyService.editAgencyUser(agencyId, agencyUser).catch(
        async (err) => {
          const responseBody = await err.response.json();
          ToastService.error(responseBody.msg);
          throw err;
        }
      )) as BackednResponse<Agency>;
    },
    options: {
      queryKey: AGENCY_LIST_QUERY_KEY,
      skipInvalidation: false,
    },
    onSuccess: (c, _, { agencyId }) => {
      c.invalidateQueries({ queryKey: AGENCY_LIST_QUERY_KEY });
      c.invalidateQueries({
        queryKey: [...AGENCY_LIST_QUERY_KEY, agencyId],
      });
    },
  });

  return {
    editAgencyUser,
    isEditing,
    isEdited,
  };
}
